import { render, staticRenderFns } from "./beautiful-date.vue?vue&type=template&id=8b29b5f8"
import script from "./beautiful-date.vue?vue&type=script&lang=js"
export * from "./beautiful-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports